import { isHouseholdMemberPhotoResponse, } from '@urbanik/api-contracts';
export class HouseholdMemberPhotoApiError extends Error {
}
const endpoint = (base, memberId, householdId, householdMemberId) => `${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/households/${encodeURIComponent(householdId)}/members/${encodeURIComponent(householdMemberId)}/photo`;
async function response(r) {
    const payload = await r.json().catch(() => null);
    if (!r.ok)
        throw new HouseholdMemberPhotoApiError(payload && typeof payload.message === 'string'
            ? payload.message
            : 'No pudimos gestionar la fotografía.');
    if (!isHouseholdMemberPhotoResponse(payload))
        throw new HouseholdMemberPhotoApiError('El servidor devolvió una fotografía inválida.');
    return payload;
}
export async function getHouseholdMemberPhoto(base, memberId, householdId, householdMemberId, signal) {
    let r;
    try {
        r = await fetch(endpoint(base, memberId, householdId, householdMemberId), {
            credentials: 'include',
            headers: { Accept: 'application/json' },
            signal: signal ?? null,
        });
    }
    catch {
        throw new HouseholdMemberPhotoApiError('No pudimos conectar con el servidor.');
    }
    return response(r);
}
export async function uploadHouseholdMemberPhoto(base, memberId, householdId, householdMemberId, file) {
    const form = new FormData();
    form.append('file', file);
    let r;
    try {
        r = await fetch(`${endpoint(base, memberId, householdId, householdMemberId).replace(/\/photo$/, '')}/photos`, {
            method: 'POST',
            credentials: 'include',
            body: form,
            headers: { Accept: 'application/json' },
        });
    }
    catch {
        throw new HouseholdMemberPhotoApiError('No pudimos conectar con el servidor.');
    }
    return response(r);
}
export async function removeHouseholdMemberPhoto(base, memberId, householdId, householdMemberId, photoId, reason) {
    let r;
    try {
        r = await fetch(`${endpoint(base, memberId, householdId, householdMemberId)}/${encodeURIComponent(photoId)}/remove`, {
            method: 'POST',
            credentials: 'include',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ reason }),
        });
    }
    catch {
        throw new HouseholdMemberPhotoApiError('No pudimos conectar con el servidor.');
    }
    return response(r);
}
